import { startCase } from "lodash";

import { LearnerLessonType } from "@hubcapp/types";

export const learnerLessonTypeToString = (
  type: LearnerLessonType | null | undefined,
): string => {
  if (type === null || type === undefined) {
    return "";
  }
  if (type === LearnerLessonType.Dit) {
    return "DIT";
  }
  return startCase(type) || "";
};
